"use strict";
export const ajaxURL = 'https://' + location.href.match('https://(.*?)/(.*?)/')[1];
export const ajaxTimeout = 90000;

export const menu_width = 300;
export const VERTICAL_PRODUCTS = ['id_82', 'id_87'];
export const PLUGIN_PRODUCTS = [];
export const UNITS_USING_ACCU_PRECP = ['WRA', 'PRO', 'PRO2'];
export const UNITS_PUB = ['pub', 'xnewpub', 'xxUIUXxx', 'prepub'];
export const UNITS_PRO = ['PRO', 'ROCAF'];
export const UNITS_CAA = ['CAA'];
export const DOTTED_GEOJSON = ['geomap', 'convection'];
export const STATIC_SVG_ROOT = '/static/images/svg/'
